const APIS = {
  SMS: "/get-sms-count/",
  // SMS_HISTORY:"/download/api/sms-history/",
  SMS_HISTORY: "/smsemailservice/api/sms-history/",
  EMAIL_HISTORY: "/smsemailservice/api/email-history/",
  CONTACT_GROUP: "/contactservice/api/contact-groups/",
  CONTACT: "/contactservice/api/contacts/",
  EMAILS: "/contactservice/api/emails/",
  SMS_CAMPAIGN: "/smsemailservice/api/sms-campaign/",
  EMAIL_CAMPAIGN: "/smsemailservice/api/email-campaign/",
  WEBSITE: "/get-website/",
  PHONES: "/contactservice/api/phones/",
  ADDRESSES: "/contactservice/api/addresses/",
  SEND_EMAIL: "/smsemailservice/api/send-email/",
  SEND_SMS: "/smsemailservice/api/send-sms/",
  FILE_HANDLER: "/driveservice/api/file/",
  SEARCH: "/contactservice/api/search/",
  SENDER_EMAIL: "/smsemailservice/api/sender-email/",
  SENDER_SMS: "/smsemailservice/api/sender-sms/",
};

export default APIS;
